// Client for the Samples Gallery API (/api/samples).
//
// Sample applications are public git repositories listed by a catalog the
// backend fetches and caches — see backend/app/services/samples_service.py.
// Importing sends the catalog ID, never a repository URL: the backend resolves
// it through the catalog, so the gallery cannot ask for anything unlisted.

import api from './client'

export interface SampleApp {
  id: string
  name: string
  summary?: string
  description?: string
  category?: string
  icon?: string
  theme_color?: string
  repository?: string
  import_ref: string
  branch?: string
  tags?: string[]
  features?: string[]
  /** Object counts by type, e.g. { K: 2, T: 3, V: 18 }. */
  objects?: Record<string, number>
  roles?: string[]
  requires?: Record<string, unknown>
  sample_data?: boolean
  published?: string
}

export interface SampleCatalog {
  applications: SampleApp[]
  source: string
  fetched_at: number
  /** The catalog could not be reached; these are the last known applications. */
  stale: boolean
  error: string | null
  /** Sample id → the caller's project that already holds it (one copy each). */
  imported?: Record<string, string>
}

export interface SampleImportResult {
  success: boolean
  /** Refused because the caller already has this sample; project_id names it. */
  already_imported?: boolean
  project_id?: string
  file_count?: number
  error?: string
  sample?: SampleApp
}

export async function fetchSamples(refresh = false): Promise<SampleCatalog> {
  const { data } = await api.get('/samples', { params: refresh ? { refresh: true } : {} })
  return data
}

export async function importSample(id: string): Promise<SampleImportResult> {
  const { data } = await api.post('/samples/import', { id })
  return data
}
